module.exports = __webpack_public_path__ + "img/3-3.7ce7b88a.jpg";